import {RouteDefinition} from '../../../../routes';
import {SIPDetailScreen} from './SIPDetailScreen';

export const SIPSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/gateway/:id/sip',
        component: SIPDetailScreen,
    },
];
